import { Center, LoadingOverlay } from "@mantine/core";
import { usePatronStatus } from "@/api/fapinstructor/patreon/get-patreon-status";
import { RedirectPatrons } from "@/components/redirect-patrons";
import { hasRequiredMembership } from "@fapinstructor/common";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";
import { UnsubscribedPatreonCard } from "./-components/unsubscribed-patreon-card";
import { LinkPatreonCard } from "./-components/link-patreon-card";

export const Route = createFileRoute("/_authenticated/patreon/signup/")({
  component: PatreonSignupRouteComponent,
});

export function PatreonSignupRouteComponent() {
  return (
    <Page title="Patreon Signup">
      <PatreonSignupPageContent />
    </Page>
  );
}

function PatreonSignupPageContent() {
  const patronStatusQuery = usePatronStatus();

  if (patronStatusQuery.isFetching) {
    return (
      <LoadingOverlay
        visible={true}
        zIndex={1000}
        overlayProps={{ opacity: 1, blur: 1 }}
        loaderProps={{ color: "pink", type: "bars" }}
      />
    );
  }

  const linked = patronStatusQuery.data?.linked;
  const currentMembershipTier =
    patronStatusQuery.data?.membershipTier ?? "free";
  const subscribed = hasRequiredMembership(currentMembershipTier, "follower");

  return (
    <RedirectPatrons>
      <Center h="100%">
        {linked && !subscribed ? <UnsubscribedPatreonCard /> : null}
        {!linked && !subscribed ? <LinkPatreonCard /> : null}
      </Center>
    </RedirectPatrons>
  );
}
